<template>
  <div id="wrapper" class="admin" v-loading="isLoading">
    <shop-select-dialog ref="shopSelectDialog" />
    <div id="header">
      <router-link :to="{name: 'Home'}" class="home">ホーム</router-link>
      <a href="#" class="shop" @click="showShopSelectDialog" v-show="shopName">{{ shopName }}</a>
      <router-link :to="{name: 'ShopSelect'}" class="shop-select" v-show="isAgencyUser"></router-link>
      <a href="#" @click="performLogout" class="logout">ログアウト</a>
    </div>
    <div id="main">
      <div class="menu">
        <ul>
          <router-link tag="li" class="home" :to="{name: 'Home'}"><a>ホーム</a></router-link>
          <li class="customer" v-if="hasCrmLicense"><a href="#" @click="moveTo('customer')">顧客</a></li>
          <li class="list" v-if="hasCrmLicense"><a href="#" @click="moveTo('member_list')">顧客リスト</a></li>
          <li class="promotion" v-if="hasCrmLicense"><a href="#" @click="moveTo('promotion')">プロモーション</a></li>
          <li class="tag" v-if="hasCrmLicense"><a href="#" @click="moveTo('tag')">タグ</a></li>
          <li class="purpose" v-if="hasCrmLicense"><a href="#" @click="moveTo('purpose')">来店用途</a></li>
          <router-link tag="li" class="daily" :to="{name: 'ReportDaily'}" v-if="hasSalesReportLicense"><a>日報</a></router-link>
          <router-link tag="li" class="sales_item" :to="{name: 'ReportSalesItem'}" v-if="hasSalesReportLicense"><a>商品別売上</a></router-link>
          <router-link tag="li" class="sales_payment" :to="{name: 'ReportSalesPayment'}" v-if="hasSalesReportLicense"><a>支払別売上</a></router-link>
          <router-link tag="li" class="sales_category" :to="{name: 'ReportSalesCategory'}" v-if="hasSalesReportLicense"><a>カテゴリー別売上</a></router-link>
          <router-link tag="li" class="payment_note" :to="{name: 'ReportPaymentAnalyze'}" v-if="hasSalesReportLicense"><a>支払管理表</a></router-link>
          <router-link tag="li" class="sales_time" :to="{name: 'ReportPaymentTime'}" v-if="hasSalesReportLicense"><a>時間売上</a></router-link>
          <router-link tag="li" class="sales_weekday" :to="{name: 'ReportSalesWeekday'}" v-if="hasSalesReportLicense"><a>曜日売上</a></router-link>
          <router-link tag="li" class="analize" :to="{name: 'ReportSalesAnalyze'}" v-if="hasSalesReportLicense"><a>売上分析</a></router-link>
          <router-link tag="li" class="sales_staff" :to="{name: 'ReportSalesStaff'}" v-if="hasSalesReportLicense"><a>担当者別売上</a></router-link>
          <router-link tag="li" class="cash_note" :to="{name: 'ReportCashNote'}" v-if="hasSalesReportLicense"><a>現金管理表</a></router-link>
          <router-link tag="li" class="audit" :to="{name: 'ReportAudit'}" v-if="hasSalesReportLicense"><a>監査レポート</a></router-link>
          <router-link tag="li" class="budget" :to="{name: 'ReportSalesBudget'}" v-if="hasSalesReportLicense"><a>予算入力</a></router-link>
          <router-link tag="li" class="shop_sales_analyze" :to="{name: 'ReportShopSalesAnalyze'}" v-if="hasSalesReportLicense && isGroupMode"><a>店舗別売上分析</a></router-link>
          <router-link tag="li" class="sales_month" :to="{name: 'ReportSalesMonth'}" v-if="hasSalesReportLicense && isGroupMode"><a>月別売上分析</a></router-link>
          <router-link tag="li" class="shop_payment_note" :to="{name: 'ReportShopPaymentNote'}" v-if="hasSalesReportLicense && isGroupMode"><a>店舗別支払管理</a></router-link>
          <router-link tag="li" class="shop_menu_sales" :to="{name: 'ReportShopMenuSales'}" v-if="hasSalesReportLicense && isGroupMode"><a>店舗別メニュー売上</a></router-link>
          <li class="setting list" :class="{on: isOpenSettingSubMenu}"><a href="#" @click="isOpenSettingSubMenu = !isOpenSettingSubMenu">設定</a>
            <ul class="sub">
              <router-link tag="li" class="settings" :to="{name: 'Settings'}" v-if="hasSalesReportLicense"><a>設定</a></router-link>
              <router-link tag="li" class="department" :to="{name: 'Department'}" v-if="hasSalesReportLicense && hasShop"><a>部門</a></router-link>
              <router-link tag="li" class="category" :to="{name: 'Category'}" v-if="hasSalesReportLicense && hasShop"><a>グループカテゴリー</a></router-link>
              <router-link tag="li" class="time_setting" :to="{name: 'TimeSetting'}" v-if="hasSalesReportLicense && hasShop"><a>時間帯</a></router-link>
            </ul>
          </li>
        </ul>
      </div>
      <div class="content">
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import SERVER_TYPE from '@/consts/serverTypes'

import ShopSelectDialog from './ShopSelectDialog'

export default {
  name: 'MainLayout',
  components: {
    ShopSelectDialog,
  },
  data () {
    return {
      isLoading: false,
      isOpenSettingSubMenu: false,
    }
  },
  computed: {
    ...mapGetters('account', [
      'asGroup',
      'isGroupMode',
      'shopName',
      'isAgencyUser',
      'hasShop',
      'hasGroup',
      'hasCrmLicense',
      'hasSalesReportLicense',
      'hasReserveLicense',
    ]),
  },
  methods: {
    ...mapActions({
      logout: 'account/logout',
    }),
    performLogout () {
      this.logout().then(() => {
        this.$router.push({'name': 'Login'})
      })
    },
    moveTo (to) {
      this.isLoading = true
      this.$request.auth.redirectToken().then(res => {
        const token = res.body.token
        let tmp = res.body.servers.find(x => x.serverType === SERVER_TYPE.CRM)
        const crm = tmp ? `${tmp.endpoint}account/login/${token}/` : null
        let link = ''
        switch (to) {
          case 'customer':
          case 'promotion':
          case 'tag':
          case 'purpose':
          case 'shop':
            link = crm + to
            break
          case 'category':
            link = '/category'
            break
          case 'department':
            link = '/department'
            break
        }
        if (link) {
          window.location.href = link
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    showShopSelectDialog () {
      if (this.hasGroup) {
        this.$refs.shopSelectDialog.show()
      }
    },
    handleRequestError ([body, errors]) {
      if (errors) {
        Object.keys(errors).forEach(key => {
          if (body[key]) {
            errors[key] = body[key].join('\n')
          } else {
            errors[key] = ''
          }
        })
      }

      if (body['nonFieldErrors']) {
        this.$message({
          type: 'error',
          message: body['nonFieldErrors'].join('\n'),
        })
      }
    },
  },
  created: function () {
    this.$on('requestError', this.handleRequestError)
  },
}
</script>

<style scoped>
#wrapper {
  width: 100%;
  height: 100%;
  font-size: 14px;
}

#header {
  position: fixed;
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 5px 0 0 0;
  background-color: #222528;
  box-shadow: 0 1px 0 rgba(0,0,0,0.1);
  text-align: center;
  z-index: 10;
}

#header a {
  position: absolute;
  display: block;
  width: 50px;
  height: 40px;
  top: 0;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: auto 28px;
  text-indent: -9999px;
}

#header a.home {
  background-image: url('/static/img/logo_kaleido.png');
  width: 140px;
  background-size: 122px 28px;
  left: 0;
}

#header a.shop-select {
  background-image: url('/static/img/icon/shop-select.png');
  background-position: center 5px;
  left: 200px;
}

#header a.logout {
  background-image: url('/static/img/icon/logout.png');
  background-position: center 5px;
  right: 0;
}

#header a.shop {
  background-color: #12171A;
  font-weight: normal;
  position: relative;
  display: inline;
  left: auto;
  right: auto;
  top: 8px;
  width: 100%;
  height: auto;
  padding: 6px 20px;
  margin: 0;
  border-radius: 15px;
  box-shadow: inset 1px 1px 1px rgba(0,0,0,0.2);
  line-height: 1;
  text-indent: 0;
  text-decoration: none;
  text-align: center;
  text-shadow: 1px 1px 1px rgba(0,0,0,0.2);
  font-size: 14px;
  color: #FFF;
}

#header a.account {
  background-image: url('/static/img/icon/gear.png');
  right: 60px;
}

#main {
  position: fixed;
  height: 100%;
  width: 100%;
}

#main .menu {
  position: absolute;
  box-sizing: border-box;
  width: 200px;
  height: 100%;
  top: 0;
  left: 0;
  padding-top: 40px;
  background-color: #FFF;
  z-index: 0;
  overflow: auto;
}

img {
  border: none;
  vertical-align: bottom;
}

ul, ol, dl, li {
  margin: 0;
  padding: 0;
}

ul, ol, dl {
  list-style: none;
}

li {
  display: list-item;
}

ul, li, div {
  position: relative;
}

#main .menu ul {
  display: block;
  overflow: hidden;
}

#main .menu ul li {
  width: 50%;
  height: 80px;
  box-sizing: border-box;
  border-bottom: 1px solid #DDD;
  float: left;
  margin: 0;
  padding: 0;
}

#main .menu ul li:nth-child(odd) {
  border-right: 1px solid #DDD;
}

#main .menu ul li:nth-child(even) {
  border-right: 1px solid #DDD;
}

#main .menu ul li a {
  display: block;
  height: 80px;
  box-sizing: border-box;
  padding: 60px 0 0 0;
  background-position: center 16px;
  background-size: 40px 40px;
  background-repeat: no-repeat;
  border-bottom: 1px solid #DDD;
  font-size: 10px;
  line-height: 1.2;
  color: #68ADD2;
  text-decoration: none;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#main .menu ul li.on a,
#main .menu ul li.current a,
#main .menu ul li a:hover {
  background-color: #F9FDFF;
  color: #68ADD2;
}
#main .menu ul li.home a {
  background-image: url(/static/img/top_icon/home.png);
}
#main .menu ul li.home.current a,
#main .menu ul li.home a:active  {
  background-image: url(/static/img/top_icon/home_on.png);
}
#main .menu ul li.customer a {
  background-image: url(/static/img/top_icon/customer.png);
}
#main .menu ul li.customer.current a,
#main .menu ul li.customer a:active {
  background-image: url(/static/img/top_icon/customer_on.png);
}
#main .menu ul li.list a {
  background-image: url(/static/img/top_icon/list.png);
}
#main .menu ul li.list.current a,
#main .menu ul li.list a:active {
  background-image: url(/static/img/top_icon/list_on.png);
}
#main .menu ul li.promotion a {
  background-image: url(/static/img/top_icon/promotion.png);
}
#main .menu ul li.promotion.current a,
#main .menu ul li.promotion a:active {
  background-image: url(/static/img/top_icon/promotion_on.png);
}
#main .menu ul li.daily a {
  background-image: url(/static/img/top_icon/calendar.png);
}
#main .menu ul li.daily.current a,
#main .menu ul li.daily a:active {
  background-image: url(/static/img/top_icon/calendar_on.png);
}
#main .menu ul li.sales_item a {
  background-image: url(/static/img/top_icon/sales_shohin.png);
}
#main .menu ul li.sales_item.current a,
#main .menu ul li.sales_item a:active {
  background-image: url(/static/img/top_icon/sales_shohin_on.png);
}
#main .menu ul li.sales_payment a {
  background-image: url(/static/img/top_icon/sales_shiharai.png);
}
#main .menu ul li.sales_payment.current a,
#main .menu ul li.sales_payment a:active {
  background-image: url(/static/img/top_icon/sales_shiharai_on.png);
} 
#main .menu ul li.sales_category a {
  background-image: url(/static/img/top_icon/sales_category.png);
}
#main .menu ul li.sales_category.current a,
#main .menu ul li.sales_category a:active {
  background-image: url(/static/img/top_icon/sales_category_on.png);
}
#main .menu ul li.payment_note a {
  background-image: url(/static/img/top_icon/payment_note.png);
}
#main .menu ul li.payment_note.current a,
#main .menu ul li.payment_note a:active {
  background-image: url(/static/img/top_icon/payment_note_on.png);
}
#main .menu ul li.sales_time a {
  background-image: url(/static/img/top_icon/sales_time.png);
}
#main .menu ul li.sales_time.current a,
#main .menu ul li.sales_time a:active {
  background-image: url(/static/img/top_icon/sales_time_on.png);
}
#main .menu ul li.sales_weekday a {
  background-image: url(/static/img/top_icon/sales_weekday.png);
}
#main .menu ul li.sales_weekday.current a,
#main .menu ul li.sales_weekday a:active {
  background-image: url(/static/img/top_icon/sales_weekday_on.png);
}
#main .menu ul li.analize a {
  background-image: url(/static/img/top_icon/analize.png);
}
#main .menu ul li.analize.current a,
#main .menu ul li.analize a:active {
  background-image: url(/static/img/top_icon/analize_on.png);
}
#main .menu ul li.shop_sales_analyze a {
  background-image: url(/static/img/top_icon/shop_sales_analyze.png);
}
#main .menu ul li.shop_sales_analyze.current a,
#main .menu ul li.shop_sales_analyze a:active {
  background-image: url(/static/img/top_icon/shop_sales_analyze_on.png);
}
#main .menu ul li.sales_staff a {
  background-image: url(/static/img/top_icon/sales_staff.png);
}
#main .menu ul li.sales_staff.current a,
#main .menu ul li.sales_staff a:active {
  background-image: url(/static/img/top_icon/sales_staff_on.png);
}
#main .menu ul li.cash_note a {
  background-image: url(/static/img/top_icon/cash_note.png);
}
#main .menu ul li.cash_note.current a,
#main .menu ul li.cash_note a:active {
  background-image: url(/static/img/top_icon/cash_note_on.png);
}
#main .menu ul li.audit a {
  background-image: url(/static/img/top_icon/audit.png);
}
#main .menu ul li.audit.current a,
#main .menu ul li.audit a:active {
  background-image: url(/static/img/top_icon/audit_on.png);
}
#main .menu ul li.budget a {
  background-image: url(/static/img/top_icon/budget.png);
}
#main .menu ul li.budget.current a,
#main .menu ul li.budget a:active {
  background-image: url(/static/img/top_icon/budget_on.png);
}
#main .menu ul li.tag a {
  background-image: url(/static/img/top_icon/tag.png);
}
#main .menu ul li.tag.current a,
#main .menu ul li.tag a:active {
  background-image: url(/static/img/top_icon/tag_on.png);
}
#main .menu ul li.category a {
  background-image: url(/static/img/top_icon/category.png);
}
#main .menu ul li.category.current a,
#main .menu ul li.category a:active {
  background-image: url(/static/img/top_icon/category_on.png);
}
#main .menu ul li.setting a {
  background-image: url(/static/img/top_icon/setting.png);
}
#main .menu ul li.setting.current a,
#main .menu ul li.setting a:active {
  background-image: url(/static/img/top_icon/setting_on.png);
}
#main .menu ul li.purpose a {
  background-image: url(/static/img/top_icon/purpose.png);
}
#main .menu ul li.purpose.current a,
#main .menu ul li.purpose a:active {
  background-image: url(/static/img/top_icon/purpose_on.png);
}
#main .menu ul li.shop_payment_note a {
  background-image: url(/static/img/top_icon/shop_payment_note.png);
}
#main .menu ul li.shop_payment_note.current a,
#main .menu ul li.shop_payment_note a:active {
  background-image: url(/static/img/top_icon/shop_payment_note_on.png);
}
#main .menu ul li.sales_month a {
  background-image: url(/static/img/top_icon/sales_month.png);
}
#main .menu ul li.sales_month.current a,
#main .menu ul li.sales_month a:active {
  background-image: url(/static/img/top_icon/sales_month_on.png);
}
#main .menu ul li.shop_menu_sales a {
  background-image: url(/static/img/top_icon/shop_menu_sales.png);
}
#main .menu ul li.shop_menu_sales.current a,
#main .menu ul li.shop_menu_sales a:active {
  background-image: url(/static/img/top_icon/shop_menu_sales_on.png);
}
#main .menu {
  overflow: auto;
}
#main .menu > ul {
  clear: both;
  box-shadow: 0 -1px 0 0 #DDD;
}
#main .menu > ul > li:nth-child(odd) {
  float: left;
}
#main .menu > ul > li:nth-child(even) {
  float: right;
}
#main .menu > ul > li.on {
  height: auto;
  border-bottom: none;
}
#main .menu ul li .sub li,
#main .menu ul li .sub li a {
  display: block;
  width: 100%;
  height: auto;
  background: none;
  border: none;
}
#main .menu ul li .sub li {
  overflow: hidden;
}
#main .menu ul li .sub li a {
  height: 0;
  padding: 0 12px;
  text-align: left;
  transition-property: all;
  transition-duration: .5s;
}
#main .menu ul li.on .sub li a {
  height: 37px;
  line-height: 36px;
  border-bottom: 1px solid #DDD;
}
#main .menu ul li.on .sub li a,
#main .menu ul li.on .sub li a:hover
#main .menu ul li.on .sub li a:active {
  background: none;
}
#main .menu ul li.on .sub {
  display: block;
  width: 200%;
  max-height: 220px;
  overflow: auto;
  background-color: #FCFEFF;
  z-index: 1;
}
#main .menu ul li:nth-child(odd).on .sub {
  float: left;
}
#main .menu ul li:nth-child(even).on .sub {
  float: right;
}
#main .menu ul li.on > a {
  position: relative;
  background-color: #F9FDFF;
  overflow: visible;
}
#main .menu ul li.on > a:before,
#main .menu ul li.on > a:after {
  content: '';
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  bottom: 0;
  left: 50%;
  margin-left: -6px;
  border: 6px solid transparent;
  border-bottom: 6px solid #DDD;
  z-index: 1;
}
#main .menu ul li.on > a:after {
  margin-bottom: -1px;
  border-bottom: 6px solid #FCFEFF;
}

#main .content {
  width: calc(100% - 200px);
  left: 200px;
  box-shadow: none;
  background-color: #F3F7F9;
  background: radial-gradient(#F3F7F9, #F3F7F9);
  box-shadow: -1px 0 0 0 #DDD;
  font-family: "Futura", "Century Gothic", sans-serif;

  overflow: scroll;
  position: absolute;
  box-sizing: border-box;
  height: 100%;
  top: 0;
  padding: 40px 0;
  z-index: 5;
  transition-property: width, left;
  transition-duration: 0.2s, 0.2s;
}

</style>



// WEBPACK FOOTER //
// src/components/Layout/Main.vue